module.exports = "<svg viewBox=\"0 0 299.2 112.3\"><path d=\"M35.6 98.6C17.1 98.5 2 83.5 2 65h18.9c0 8.1 6.6 14.7 14.7 14.7S50.3 73.1 50.3 65h18.9c0 18.5-15.1 33.6-33.6 33.6z\" class=\"st0\"></path><path d=\"M11.4 20.5c-5.3 0-9.5-4.3-9.5-9.6s4.3-9.5 9.6-9.5c5.2 0 9.5 4.3 9.5 9.5 0 5.4-4.3 9.6-9.6 9.6.1 0 0 0 0 0z\" class=\"st0\"></path><path d=\"M59.7 20.5c-5.3 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5 9.5 4.3 9.5 9.5c.1 5.3-4.2 9.5-9.5 9.5z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-event.svg
// module id = 286
// module chunks = 1